<div class="moneyball-sample tw-relative tw-w-full tw-h-screen tw-overflow-hidden">
  <!-- Full-width faded background image -->
  <img
    src="assets/img/moneyball-battle-sample.png"
    class="tw-w-full tw-h-full tw-object-cover tw-filter tw-brightness-50 tw-contrast-110 tw-opacity-50"
    alt="Background Image" />

  <!-- Pricing Card alternative -->
  <div
    class="tw-absolute tw-top-[46%] tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2 tw-z-10">
    <div
      class="tw-flex tw-flex-col tw-p-6 tw-mx-auto tw-max-w-lg tw-text-center tw-text-gray-900 tw-rounded-lg tw-border tw-border-gray-100 tw-border-solid tw-shadow xl:tw-p-8 tw-min-w-[250px] xs:tw-min-w-96 tw-bg-white tw-bg-opacity-90">
      <h3
        class="tw-text-2xl tw-font-semibold tw-flex tw-items-center tw-justify-center tw-mb-1 tw-mt-2">
        <mat-icon class="tw-pr-2">query_stats</mat-icon>
        Moneyball
      </h3>
      <p class="tw-text-gray-500 sm:tw-text-lg tw-mt-0">Real-Time Workforce Intelligence</p>

      <div
        class="tw-p-4 tw-mb-4 tw-text-blue-800 tw-border tw-border-blue-300 tw-border-solid tw-rounded-lg tw-bg-blue-100"
        role="alert">
        <!-- General message -->
        <div>
          <h3>
            <a
              class="tw-text-blue-600 text-lg font-medium tw-mt-0 hover:tw-text-blue-700 hover:tw-underline hover:tw-underline-offset-4 tw-flex tw-items-center tw-gap-2"
              href="https://app.workforce.ai">
              Try the new Workforce.ai experience!
              <mat-icon>arrow_forward</mat-icon>
            </a>
          </h3>
        </div>
      </div>
    </div>
  </div>
</div>
